<script>
import appConfig from "@/app.config";
import ItemsApi from "@/services/items-api";

export default {
  page: {
    title: "Démarrer l'expérience",
    meta: [{ name: "description", content: appConfig.description }]
  },
  data() {
    return {
      task:0,
      selectedCategory:null,
      selectedModel:null,
      selectedTypesId: [],
      selectedPaperType: null,
      selectedPaperColor: null,
      bagCode: null,

      itemsList:[],
      showItemsSpinner:false,
      pagemodel: {currentPage : 1, perPage : 10, totalRows: 0},
      reference: null,
      sectionName: null,
      categories:null,
      requestedPaperTypeUnavailableMessage: null,
      taskKey: 0,
      
    };
  },

  watch: {
  '$route': {
          immediate: true,
          deep: true, 
          handler(route) {
            this.reference = route.params.refItem;
            this.sectionName = route.params.sectionName;

            if((this.sectionName == undefined  && this.reference == undefined) || (!this.sectionName  && !this.reference ) ){
              this.task = 0
            } else if(this.sectionName != undefined  && this.reference == undefined){
              this.task = 1
            } else{
              this.task = 2
            }
            if(this.task == 1){
              this.findItems(true);
            }else{
              this.findItems(false);
            }

          }
      },
  },


      computed: {

        subTitle(){

          switch (this.task) {
            case 0: return this.$t('startExperience.subTitle1');
            case 1: return this.$t('startExperience.subTitle2');
            case 2: return this.$t('startExperience.subTitle3');
            case 3: return this.$t('startExperience.subTitle4');
            default : return this.$t('startExperience.subTitle1');
          }

        },

        isSupportedAntiGraisse() {
          return this.itemsList?.length && this.itemsList[0].supportedAntiGraisse;
        },

    },

  mounted(){
    this.getAllSection()
    this.findItems(false)
    if(this.task==2){
      this.$nextTick(() => {
        this.adjustTitlesWidth();
      });

    }
      
  },
  updated() {
    if(this.task==2){
      this.$nextTick(() => {
        this.adjustTitlesWidth();
      });
    }  
  },
  methods: {
    adjustTitlesWidth() {
      if(this.task==2){
      this.$nextTick(() => {
        const titles = this.$el.querySelectorAll(".variant-title");
        const infoArea = this.$el.querySelectorAll(".variant-item-info");
        if (!titles.length) return;

          titles.forEach(t => {
            t.style.minWidth = 'auto';
          });

          infoArea.forEach(t => {
            t.style.minWidth = 'auto';
          });


          let maxWidth = 0;

          titles.forEach(t => {
            if (t.offsetWidth > maxWidth) maxWidth = t.offsetWidth;
          });
          infoArea.forEach(t => {
            t.style.setProperty("min-width", maxWidth + "px", "important");
          });
        });
      }
    },

    getAllSection(){
        ItemsApi.getAllSection().then(
            result =>{
                this.categories = result 
            }
        )
    },

    findItems(isLightData) {
      this.showItemsSpinner = true;
      ItemsApi.findItems(this.pagemodel.currentPage, this.pagemodel.perPage,isLightData,   this.reference, this.sectionName ).then(itemsList => {
            
        if(itemsList){

          this.itemsList = itemsList.list
          this.pagemodel.totalRows = itemsList.total;
          this.pagemodel.currentPage = itemsList.page;
          this.pagemodel.perPage = itemsList.pageSize;
          this.pagemodel.pageSize = itemsList.pageSize;
          this.pagemodel.maxPagesCount = itemsList.maxPagesCount;
                
          } else {

            this.itemsList = []
            this.pagemodel.totalRows = 0;
            this.pagemodel.currentPage = 1;
            this.pagemodel.maxPagesCount = 0;
          }
        })
          .finally(() => {
              this.showItemsSpinner = false;
          })
      },

    setSelectedType(typeId) {
      const index = this.selectedTypesId.indexOf(typeId);
      if (index > -1) {
        this.selectedTypesId.splice(index, 1);
      } else {
        this.selectedTypesId.push(typeId);
      }
    },

    nextTask(){
      this.taskKey++;
      if(this.selectedTypesId && this.selectedTypesId.length){
        if (this.task == 2) {
          if(!this.isSupportedAntiGraisse){
            this.selectPaperType(0);
          }
          this.task = 3;
          return;
        }
      }
    },

    previousTask(){
      this.taskKey++;
      if(this.task > 0){
        if(this.task==3){
          this.selectedPaperType = null
          this.selectedPaperColor = null

        }

        this.task--;

        if (this.task < 2) {
          this.selectedTypesId =[]
          const parts = this.$route.path.split('/').filter(Boolean);
          parts.pop();
          const newPath = '/' + parts.join('/');
          this.$router.push(newPath);
        }
      }
    },

    selectPaperType(paperType){
      this.selectedPaperType = paperType
      this.requestedPaperTypeUnavailableMessage = null;
      const unavailable = [];
      const type = paperType === 0 ? 'Kraft' : 'ingraissable';
      const otherType = paperType === 0 ? 'ingraissable' : 'Kraft';

      if (this.selectedPaperType === 0) {
        // console.log("selected is Kraft ")
        this.itemsList.forEach(element => {
          element.variants.forEach(variant => {
            if (this.selectedTypesId.includes(variant.id) && variant.isKraft === false) {
              unavailable.push(variant.title);
            }
          });
        });

      } else if (this.selectedPaperType === 1) {
        // console.log("selected is AntiGraisse ")
        this.itemsList.forEach(element => {
          element.variants.forEach(variant => {
            if (this.selectedTypesId.includes(variant.id) && variant.isAntiGraisse === false) {
              unavailable.push(variant.title);
            }
          });
        });
      }

      if (!unavailable || unavailable.length === 0){
         this.requestedPaperTypeUnavailableMessage = null;
         return;
      } 
      const plural = unavailable.length > 1;
      const demo = plural ? 'ces types de sacs' : 'ce type de sac';

      this.requestedPaperTypeUnavailableMessage =`<span>Le papier ${type} n’est pas disponible pour <strong>${unavailable.join(', ')}. </strong>` +
           `Le papier ${otherType} sera utilisé pour ${demo}.</span>`;

    },

    
    selectPaperColor(paperColor){
      this.selectedPaperColor = paperColor
      this.addToCart()
    },

    addToCart() {
      if (this.selectedTypesId  == null  || this.selectedTypesId.length === 0 || this.selectedPaperType  == null || this.selectedPaperColor  == null ) {
        return;
      }
      const itemsToAdd = this.selectedTypesId.map(typeId => ({ itemVariantId: typeId, paperType: this.selectedPaperType , paperColor: this.selectedPaperColor }));
      this.$store.dispatch('addToCart', itemsToAdd).then((cart)=>{
          const bagCode = cart?.lines?.list?.[0]?.bagDesignCode;
          if (bagCode != null && bagCode != 'undefined') {
              this.$router.push({ path: "/personnalisation-produit/" + bagCode });
          }
        })  
    }, 
    
    goHome() {
      this.$router.push('/');
    }


  }
};
</script>


<template>
  <div class="startExpImg">
        <vue-snotify></vue-snotify>

    <div class="row align-items-center">
      <div class="col-12 d-flex justify-content-between align-items-center">
        <router-link class="d-none d-sm-block" to="/" title="Accueil">
          <img src="@/assets/icons/next.svg" height="35px" alt="Home" class="pr-4 pt-3"   style="transform: scaleX(-1);"  />
        </router-link>
        <router-link class="d-sm-none"  to="/">
          <img src="@/assets/icons/next.svg" height="20px" alt="Home" class="pr-2"   style="transform: scaleX(-1);" />
        </router-link>
        <router-link to="/">
          <img src="@/assets/images/logo.png" height="90px" alt="Logo" class="pt-3 mr-5" />
        </router-link>
        <div class="d-flex" style="width: auto;"></div>
      </div>
    </div>

    <div class="row">

      <div class="col-4 col-lg-4 pr-3 text-center text-lg-right pt-4 pt-lg-2" :class="task == 0 ? ' d-none d-sm-block' : ''" >
          <img  alt="" width="35px" v-if="task !== 0"
              style="cursor: pointer; border:1px solid #ddd; border-radius:50%; box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);" 
              src="@/assets/icons/arrow-left.svg"
              class="p-2"
              @click="previousTask()"/>  
      </div>

      <div class=" text-center pt-3 pt-lg-0 "  :class="task === 0 ? 'col-12 col-sm-4' : 'col-4' ">

       

        <span class="text-center text-dark text-uppercase font-size-16">étape {{ this.task + 1 }}/4</span>
        <h2 :key="this.task" class=" text-dark font-weight-bold mt-2 banner-subtitle">
            {{  this.subTitle}}
          </h2>

         

      </div>

      <div class="col-3 pl-3 text-center text-lg-left pt-4 pt-lg-2" >
          <img v-if="task == 3 || (task == 2 && selectedTypesId.length > 0 )" alt="" width="35px" 
              style="cursor: pointer; border:1px solid #ddd; border-radius:50%; box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);" 
              src="@/assets/icons/arrow-right.svg"
              class="p-2"
              @click="nextTask()"/>  
      </div>

    </div>

      <div v-if="task == 0" class="row d-flex text-center justify-content-center align-items-center no-gutters category-section mt-lg-5 pt-lg-5 pb-5 px-3 px-lg-5">
        <div v-for="(category, index) in categories" :key="index" class="col-12 col-sm-6 col-lg-3 d-flex justify-content-center align-items-center category-box w-100 px-3">
          <router-link  :to="'/demarrer-experience/'+ category.seoName">
            <div  style="cursor:pointer;">

              <div class=" d-flex justify-content-center align-items-center">
                <!-- background: linear-gradient(to bottom, #e0e0e0, #bdbdbd); -->
                <img class="img-fluid mt-3" width="200"
                  v-bind:src="'/api/image/get/' + category.image"
                  alt="Image produit" 
                />
              </div>
              <div class="text-primary text-center font-weight-bold mt-4 font-size-20" >
                  {{ category.name }}
              </div>
              <div class="text-dark  text-center mt-3 mb-3 font-size-16 hide-description-default" >
                  {{ category.description }}
              </div>
              <div class="text-primary text-center font-weight-bold mt-3 mb-5 font-size-20" >
                  <b-button variant="outline-primary" style="letter-spacing:2px;" class="font-weight-bold text-center text-uppercase font-size-14">
                          Sélectionner
                  </b-button>
                </div>
              </div>
            </router-link>  
        </div>    

      </div>




     

    <!-- <div v-if="task == 0" class="col-12 bagsCategory  animated fadeInUp">
      <div class="row justify-content-center align-items-center h-100 ">
        <div v-for="(category, index) in categories" :key="index" class="category-container col-12 col-sm-6 col-md-4 col-lg-3 ">
            <div class="category-image" @click="setSelectedCategory(category)">
              <img :src="require('@/assets/images/' + category.image)" alt="Image produit" />
              <div class="category-overlay">
                <div class="category-button">
                  {{ category.name }}
                </div>
              </div>
            </div>
        </div>
      </div>
      </div> -->

     

     <div v-else-if="task == 1" :key="taskKey" class="row d-flex h-100 modelContainer animated fadeInUp  mt-lg-5 pt-sm-5" >
        <div v-for="(model, index) in itemsList" :key="index" class="model-container col-12 col-sm-6 col-md-4 col-xl-3 pl-3 pr-3 mb-3">
          <div>
            <router-link :to="'/demarrer-experience'+ model.url">
              <div class="category-image mt-5 mt-sm-2"  style="overflow: hidden;">

                <img    v-bind:src="'/api/image/get/' + model.mainImage"  alt="Image produit" />
                <!-- <div class="category-overlay"></div> -->
              </div>
            </router-link>
            <div class="mt-2 item-info text-dark">
              <div class="font-size-16 mt-4 pl-2 font-size-18 typeName"> {{ model.title }}</div>
            </div>
          </div>
        </div>
      </div>


         <div v-else-if="task == 2 && itemsList && itemsList.length" class="row typeContainer animated fadeInUp d-flex  align-items-center mt-lg-5 pt-sm-5" >
            <div v-for="(variant, index) in itemsList[0].variants" :key="index" class="model-container  align-items-center col-12 col-md-4   px-3 mb-3">
              <div>
                <div class="category-image mt-4"  @click="setSelectedType(variant.id)"   :class="{ selected: selectedTypesId.includes(variant.id) }"  style="overflow: hidden;     justify-self: center">
                  <img v-bind:src="'/api/image/get/' + variant.mainVariantImage" alt="Image produit" class="p-4"/>
                  <!-- <div class="category-overlay"></div> -->
                </div>
                <div class="mt-2 variant-item-info item-info  text-dark">
                  <div class="font-size-16 mt-4 pl-2 font-size-18 typeName"><span class=" variant-title">{{ variant.title }}</span></div>
                  <div class=" mt-2 pl-2 "> <strong class="font-size-16">{{ variant.priceAsString }}</strong> <span class="ml-2 font-size-12" > / sac</span></div>
                  <div class=" pl-2 pb-2"> <strong class="font-size-16">{{ variant.minQuantityOrdered }} sacs</strong> <span class="ml-2 font-size-12" > / commande</span></div>
                </div>
              </div>
            </div>
        </div>


      <div v-else-if="task == 3">
        <div v-if="this.isSupportedAntiGraisse" class="row typeContainer animated fadeInUp mt-lg-5 pt-5 mb-5 ">
          <div class="col-12 col-md-6 text-center text-md-right pr-md-3 ">
            <div class="mr-md-3">
                <b-button variant="outline-dark" :class="{ selected: selectedPaperType === 0 }" class="font-weight-bold text-center font-size-20 paperTypeButton" @click="selectPaperType(0)"
                style="width: 370px;">
                  <div class="font-size-18 text-uppercase m-3">Sac Papier Kraft</div>
                </b-button>
            </div>
          </div>
          <div class="col-12  col-md-6 text-center  text-md-left pl-md-3">
              <div class="mt-4 mt-md-0 ml-md-3">
                <b-button variant="outline-dark" :class="{ selected: selectedPaperType === 1 }" class="font-weight-bold text-center font-size-20 paperTypeButton" @click="selectPaperType(1)"
                 style="width: 370px;">
                  <div class="font-size-18 text-uppercase m-3">Sac Papier Ingraissable</div>
                </b-button>
              </div>
          </div>
          <div class="col-1" :class="[ requestedPaperTypeUnavailableMessage == null ? 'd-none': '']"></div>
          <div class="col-10 text-center text-danger font-size-16 m-2 mt-5 pr-2" :class="[ requestedPaperTypeUnavailableMessage == null ? 'd-none': '']" v-html="requestedPaperTypeUnavailableMessage"></div>
        </div>


      <div class="row typeContainer animated fadeInUp mt-lg-5 pt-5 mb-5 ">
          <div class="col-12 col-md-6 text-center text-md-right pr-md-3 ">
            <div class="mr-md-3">
                <b-button variant="outline-dark" :class="{ selected: selectedPaperColor === 0 }" class="font-weight-bold text-center font-size-20 paperTypeButton" @click="selectPaperColor(0)">
                  <div class="font-size-18 text-uppercase m-3">Papier Brun</div>
                </b-button>

            </div>
          </div>
          <div class="col-12  col-md-6 text-center  text-md-left pl-md-3">
              <div class="mt-4 mt-md-0 ml-md-3">
                <b-button variant="outline-dark" :class="{ selected: selectedPaperColor === 1 }" class="font-weight-bold text-center font-size-20 paperTypeButton" @click="selectPaperColor(1)">
                  <div class="font-size-18 text-uppercase m-3">Papier Blanc</div>
                </b-button>
              </div>
          </div>
      </div>

      </div>


  

  </div>
  
</template>


<style scoped>
.startExpImg {
  height: 100vh;
}

.category-section {
  display: flex;
  align-items: center;
  padding: 2rem;
}
.category-container {
  display: flex;
  justify-content: center;
}

.model-container {
  display: flex;
  justify-content: center;
}
.type-container {
  display: flex;
  justify-content: center;
}

.category-box {
  cursor:pointer;
  opacity: 0;
  animation: fadeInUp 0.4s ease-in-out forwards 0.2s;
}

.category-box:hover {
  background: #FFF;
  box-shadow: 1px 4px 16px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
}

.hide-description-default {
  display: none;
}

.category-box:hover .hide-description-default {
  display: block;
}

.category-image {
  cursor: pointer;
  position: relative;
  overflow: hidden;
  max-width: 250px;
  border-radius: 12px;
  /*box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);*/
  border: 1px solid #ddd;
  transition: transform 0.3s ease-in-out;
}
@media (min-width: 1200px) {
  .category-image img {
    width: 100%;
    height: auto;
    overflow: hidden;
    display: block;
    border-radius: 12px;
    object-fit: cover;
    transition: transform 1s ease;
  }
}
@media (min-width: 992px) and (max-width: 1200px){
  .category-image img {
    width: 100%;
    height: auto;
    overflow: hidden;
    display: block;
    border-radius: 12px;
    object-fit: cover;
    transition: transform 1s ease;
  }
}
@media (max-width: 991px) {
  .category-image img {
    width: 100%;
    height: auto;
    overflow: hidden;
    display: block;
    border-radius: 12px;
    object-fit: cover;
    transition: transform 1s ease;
  }
}


.category-image:hover img {
  transform: scale(1.1);
}

.category-image.selected {
  border: 2px solid #012b95 ;
  box-shadow: 0 0 10px #012b9591 ;
  transform: scale(1.02);
  object-fit: cover;
  transition: transform 1s ease;
  }



.category-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  object-fit: cover;
  transition: transform 1s ease;
  border-radius: 8px;
}

.category-image:hover .category-overlay {
  opacity: 1;
  transform: scale(1.08);
}


/* Texte des Univers */
.category-button {
  font-weight: bold;
  font-size: 1.1rem;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: #fff;
  padding: 0.5rem 1rem;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  transition: background 0.3s ease-in-out;
}

.category-image:hover .category-button {
  background: rgba(255, 255, 255, 0.5);
}

.category-link {
  text-decoration: none;
}

.banner-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: left;
}


/* .banner-title {
  font-size: 3rem;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 3px;
  opacity: 0;
  animation: fadeInUp 1.3s ease-in-out forwards 0.2s;
} */

.banner-subtitle {
  font-size: 1.5rem;
  font-weight: bold;
}

.bagsCategory{
  opacity: 0;
  animation: fadeInUp 0.4s ease-in-out forwards 0.4s;
}
.modelContainer{
  opacity: 0;
  animation: fadeInUp 0.4s ease-in-out forwards 0.4s;
}
.typeContainer{
  opacity: 0;
  animation: fadeInUp 0.4s ease-in-out forwards 0.4s;
}

.typeName{
  letter-spacing: 1.2px;
  white-space: normal;
  word-break: break-word;
  overflow: visible;
}

.paperTypeButton{

  padding: 10px 26px;
  letter-spacing:1.2px;
  border-radius: 12px;
}

.paperTypeButton.selected {
  background-color: #000; 
  color: white;
  border-color: #000; 
}

/* .item-info{
    position: absolute;
    bottom: 0;
    background-color: #ffffff5e;
    width: 100%;
  } */

/* Réactivité */
@media (min-width: 768px) and (max-width: 991px) {
  /* .banner-title {
    font-size: 2.5rem;
  } */
  
  .banner-subtitle {
    font-size: 1.2rem;
    max-width: 100%;
  }
}

@media (max-width: 767px) {
  .banner-container {
    text-align: center;
  }
  
  /* .banner-title {
    font-size: 2rem;
  } */

  .banner-subtitle {
    font-size: 1rem;
    max-width: 100%;
  }
}

@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.9); }
  to { opacity: 1; transform: scale(1); }
}

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>
